import ButtonGroup from './src/main'

ButtonGroup.install = function (Vue) {
  Vue.component(ButtonGroup.name, ButtonGroup)
}

export default ButtonGroup
